import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsService, PwaInstallService, SeoService } from '@core/services';
import { ThemeService } from '@core/services/theme.service';
import { LoadingBarComponent } from '@shared/components/loading-bar/loading-bar.component';
import { OsConfirmHostComponent } from '@shared/ui/os-confirm-host/os-confirm-host.component';
import { OsToastHostComponent } from '@shared/ui/os-toast-host/os-toast-host.component';
import { PrimeNG } from 'primeng/config';
import { ConsentBannerComponent } from './layout/consent/consent-banner.component';
import { setPrimeNGLocale } from './primeng-locale';

@Component({
	selector: 'os-root',
	templateUrl: './app.component.html',
	imports: [RouterOutlet, LoadingBarComponent, OsToastHostComponent, OsConfirmHostComponent, ConsentBannerComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
	private readonly primeng = inject(PrimeNG);
	/** Criado aqui para o tema acompanhar o sistema desde o primeiro desenho. */
	private readonly theme = inject(ThemeService);

	constructor() {
		/* Cabeçalho de cada página para buscadores e prévias; análise só depois do consentimento. */
		inject(SeoService).start();
		inject(AnalyticsService).start();
		/* Desde o começo, para não perder o aviso do Chrome de que dá para instalar no celular. */
		inject(PwaInstallService);
	}

	ngOnInit(): void {
		setPrimeNGLocale(this.primeng);
	}
}
